// index.html 또는 앱 엔트리포인트 (main.ts 등)
export const isMobile = /Mobile|Android|iPhone|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent) ||
    (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1); // iPad 감지
export const isIOS = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
//# sourceMappingURL=mobile.js.map